import React from 'react';

interface MdLinkProps {
    children: React.ReactNode & React.ReactNode[];
    href?: string;
}
export function MdLink({ children, href }: MdLinkProps) {
    let text = children[0];
    let options: string[] = [];
    // look for '[]' within the link text to handle custom options such as 'button-link'
    // E.g. [Link Text[button-link,target-blank]](https://example.com)
    if (typeof text === 'string' && text.includes('[') && text.includes(']')) {
        options = text.substring(text.indexOf('[') + 1, text.lastIndexOf(']')).split(',');
        text = text.substring(0, text.indexOf('['));
    }
    return (
        <a
            className={options.includes('button-link') ? 'btn btn-info button-link' : ''}
            href={href}
            target={options.includes('target-blank') ? '_blank' : undefined}
            rel={options.includes('target-blank') ? 'noreferrer' : undefined}
        >
            {text}
            {options.includes('target-blank') && <i className="fa-solid fa-external-link ms-2" />}
        </a>
    );
}
